// src/components/pagos/CheckoutForm.js
import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = ({ monto, onSuccess, onError }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [procesando, setProcesando] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setProcesando(true);
    setMensaje('');

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/pago-exitoso`,
      },
      redirect: 'if_required'
    });

    if (error) {
      setMensaje(error.message);
      onError?.(error);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      setMensaje('✅ ¡Pago exitoso!');
      onSuccess?.(paymentIntent);
      setTimeout(() => {
        window.location.href = '/krums?exito=true';
      }, 2000);
    }

    setProcesando(false);
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      <PaymentElement />
      
      {mensaje && (
        <div className={`mensaje-pago ${mensaje.includes('✅') ? 'exito' : 'error'}`}>
          {mensaje}
        </div>
      )}

      <button 
        type="submit" 
        disabled={!stripe || procesando}
        className="btn-pagar"
      >
        {procesando ? 'Procesando...' : `Pagar $${monto} MXN`}
      </button>
    </form>
  );
};

export default CheckoutForm;